const ViewtuckshopDetails = ({tuckshop})=> {
 
 const url = tuckshop.imageName
 const path="https://drive.google.com/uc?id=" + url

 return(

<div className="workout-details">
 <div className= "tryout">
 <h4> {tuckshop.title}</h4>
 <p><strong>Brand: </strong>{tuckshop.brand}</p>
 <p> <strong> Price:$</strong> {tuckshop.price}</p>
 <p>{tuckshop.createdAt}</p>
 </div>
 <div className="work1">
 <img src={path} alt= "no pic"/>
 </div>
</div>
 )
}

export default ViewtuckshopDetails